<template>
    <div>
        <el-form>
            <el-row :gutter="10" class="u-mt-10 u-mb-20">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Instituição">
                        <el-select @change="changeFiltros('instituicao')" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar por Instituição" clearable>
                            <el-option v-for="(item, i) in instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="9" :md="10">
                    <el-form-item label="Nome do Servidor">
                        <el-input v-model="filtro.nome" placeholder="Pesquisar por nome" @keyup.native.enter="changeFiltros('nome')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="CPF">
                        <el-input v-model="filtro.cpf" placeholder="Pesquisar por CPF" @keyup.native.enter="changeFiltros('cpf')" maxlength="191" v-mask="'###.###.###-##'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="4" :md="4">
                    <el-form-item label="Função">
                        <el-select @change="changeFiltros('funcao')" v-model="filtro.funcao" placeholder="pesquisar por função" clearable>
                            <el-option v-for="(nome, codigo) in $store.getters.mapaFuncaoServidor" :key="codigo" :label="nome" :value="Number(codigo)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="$store.state.user.tipo < 7" :xs="24" :sm="5" :md="4" class="u-text-right">
                    <router-link to="/admin/servidor/cadastro" class="btn-new-register">
                        <el-button style="margin-top: 18px;" type="primary">NOVO SERVIDOR</el-button>
                    </router-link>
                </el-col>
            </el-row>
        </el-form>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Nome</th>
                        <th>CPF</th>
                        <th>Telefone</th>
                        <th>Lotações</th>
                        <th v-if="$store.state.user.tipo < 7" style="width: 210px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ item.nome }}</td>
                        <td>{{ (item.cpf ? item.cpf : '-') }}</td>
                        <td>{{ (item.telefone ? item.telefone : '-') }}</td>
                        <td>{{ (item.lotacoes ? item.lotacoes.join(', ') : '-') }}</td>
                        <td class="u-text-center" v-if="$store.state.user.tipo < 7">
                            <el-button @click="imprimirFicha(item.id)" title="Imprimir ficha cadastral" type="primary" icon="el-icon-printer" size="mini" plain class=""></el-button>
                            <el-button @click="printHorarioProfessor(item.id)" title="Imprimir horário (professor)" type="primary" icon="el-icon-date" size="mini" plain class="u-mr-10"></el-button>
                            <router-link :to="'/admin/servidor/edit/'+ item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                            <el-button v-if="$store.state.user.tipo == 6 || $store.state.user.tipo == 8" @click="deleteServidor(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            <el-button v-if="$store.state.user.tipo == 4" @click="openDeleteServidor(item)" title="Excluir / Unificar" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

        <el-dialog :close-on-click-modal="false" title="EXCLUSÃO / UNIFICAÇÃO DE SERVIDOR" width="70%" top="40px" :visible.sync="dialogDeleteServidor" v-on:close="closeDialogDeleteServidor">
            <div v-if="dialogDeleteServidor" style="margin-top: 20px;">
                <exclusao-servidor :servidor="servidorSelected" v-on:closeModal="closeDialogDeleteServidor" />
            </div>
        </el-dialog>

    </div>
</template>
<script>
import exclusaoServidor from "../exclusao-servidor";

export default {
    data: () => ({
        statusList: false,
        instituicoes: [],
        dialogDeleteServidor: false,
        servidorSelected: {},
        filtro: {
            nome: '',
            cpf: '',
            instituicao_id: '',
            funcao: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {

        if((this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9) && this.$store.state.config.instituicao){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            this.instituicoes = [{id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome}];

        }else{

            this.instituicoes = this.$store.state.instituicoes;
        }

        this.loadingServidores()
    },
    methods: {
        imprimirFicha(id){
            window.eventBus.$emit('print', {url: '/api/pdf/renderFichaCadastralServidor', param: id});
        },
        printHorarioProfessor(id){
            window.eventBus.$emit('print', {url: '/api/pdf/renderQuadroHorarioProfessor', param: { servidor_id: id }});
        },
        openDeleteServidor(item){
            this.servidorSelected = item;
            this.dialogDeleteServidor = true;
        },
        closeDialogDeleteServidor(){
            this.dialogDeleteServidor = false;
            this.loadingServidores();
        },
        changeFiltros(index){

            if(index == 'nome'){
                this.filtro.instituicao_id = '';
                this.filtro.cpf = '';
            }

            if(index == 'cpf'){
                this.filtro.nome = '';
                this.filtro.instituicao_id = '';
            }

            this.loadingServidores();
        },
        loadingServidores(){

            this.statusList = false;
            this.items = [];

            this.filtro.nome = this.$removerAcentos(this.filtro.nome).toUpperCase();

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                for(let i in response.data.data){

                    let lt = [];

                    for(let j in response.data.data[i].lotacoes){

                        if(!response.data.data[i].lotacoes[j].data_remocao){

                            let funcao = this.$store.getters.mapaFuncaoServidor[response.data.data[i].lotacoes[j].funcao];

                            if(!lt.includes(funcao)){
                                lt.push(funcao);
                            }
                        }
                    }

                    delete response.data.data[i].lotacoes;

                    response.data.data[i].lotacoes = lt;
                }

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteServidor(id){

            this.$msgbox.confirm('Só é permitido excluir um servidor, se não existirem vinculos com o mesmo. Tem certeza que deseja continuar?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/servidor/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.loadingServidores();
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingServidores();
        }
    },
    components:{ exclusaoServidor }
}
</script>